import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { CreateACampaignComponent } from '@features/create-a-campaign';
import { CreativeLibraryComponent } from '@features/creative-library';
import { BrownfieldFallbackComponent } from 'brownfield-bridge';
import { EntitlementsService } from 'entitlements';
import { adminRoutes } from './admin.routes';

export const adexRoutes: Route[] = [
  {
    // Site visits is hosted under 'data-studio' but CPM doesn't have that permission, putting site-visits conditionally in adex
    path: 'site-visits',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions(
          {
            requireLimitedView: true,
            requireConfiguration: 'enabled',
            id: 'adex-site-visits',
          },
          ['/data-studio/site-visits'],
        ),
    ],
    loadChildren: () =>
      import('@features/site-visits').then((m) => m.FeaturesSiteVisitsModule),
  },
  // engagement funnel is hosted under 'measure-studio' but CPM doesn't have that permission, putting engagement-funnel conditionally in adex
  {
    path: 'analyze/engagement-funnel',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions(
          {
            requireHubReportsAccess: 'app.measurementStudio.accountFunnel',
            requireLimitedView: true,
            id: 'account-funnel-measure-studio-adex',
          },
          ['/measure-studio/analyze/engagement-funnel'],
        ),
    ],
    loadChildren: () =>
      import('@features/engagement-funnel').then(
        (m) => m.EngagementFunnelModule,
      ),
  },
  {
    path: 'ad-library',
    redirectTo: 'creative-library',
  },
  {
    path: 'creative-library',
    title: 'Creative Library',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions(
          {
            requireNotLimitedView: false,
            id: 'matched-accounts',
          },
          ['/adex'],
        ),
    ],
    component: CreativeLibraryComponent,
  },
  {
    path: 'campaigns-overview',
    title: 'Campaigns',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireSplitFlag: 'greenfield_campaign_overview',
        }),
    ],
    loadChildren: () =>
      import('@features/campaigns-report').then((m) => m.CampaignsReportModule),
  },
  {
    path: 'create-a-campaign',
    component: CreateACampaignComponent,
  },
  {
    path: 'matched-accounts',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions(
          {
            requireNotLimitedView: true,
            id: 'matched-accounts',
          },
          ['/adex'],
        ),
    ],
    loadChildren: () =>
      import('@features/matched-accounts').then((m) => m.MatchedAccountsModule),
  },
  {
    path: 'engagement-spikes',
    redirectTo: '/data-studio/engagement-spikes',
  },
  {
    path: 'aggregate-account-report',
    loadChildren: () =>
      import('@frontend/features/reports/aggregate-account').then(
        (m) => m.FeaturesReportsModule,
      ),
  },
  {
    path: 'aggregate-campaigns',
    title: 'Aggregate Campaigns',
    loadComponent: () =>
      import('aggregate-campaigns').then((m) => m.AggregateCampaignsComponent),
  },
  {
    path: 'multi-campaign-creation-wizard',
    loadChildren: () =>
      import('@features/multi-campaign-creation-wizard').then(
        (m) => m.MultiCampaignCreationWizardModule,
      ),
  },
  {
    path: 'campaign-details',
    loadChildren: () =>
      import('@features/campaign-details').then((m) => m.CampaignDetailsModule),
  },
  {
    path: 'forecasting-report',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireAdmin: true,
          id: 'admin',
        }),
    ],
    loadChildren: () =>
      import('@features/forecasting-report').then(
        (m) => m.forecastingReportRoutes,
      ),
  },
  {
    path: 'linkedin-integration',
    title: 'Linkedin Integration',
    loadComponent: () =>
      import('@features/linkedin-integration').then(
        (m) => m.LinkedinIntegrationComponent,
      ),
  },
  adminRoutes,
  {
    path: '**',
    component: BrownfieldFallbackComponent,
    data: {
      brownfieldRootUrlEnvKey: 'ADEX_BROWNFIELD_URL',
      brownfieldPathPrefix: 'adex/',
    },
  },
];
